// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import './assets/css/base.css'
import VueI18n from 'vue-i18n'
import axios from 'axios'

Vue.prototype.$axios = axios
axios.defaults.baseURL = '/'
// Vue.prototype.HOST = '/api'


Vue.config.productionTip = false
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale:'en',
  // fallbackLocale:'en',
  messages: {
    'en': require('./locales/en'),   // 英文语言包
    'hi': require('./locales/hi'),
    'vi': require('./locales/vi'),
    'zh-TW': require('./locales/zh-TW.json'),
    'ja': require('./locales/ja.json'),
    'th': require('./locales/th.json'),
    'ph': require('./locales/ph'),
    'de': require('./locales/de.json'),
    'fr': require('./locales/fr.json'),
    'it': require('./locales/it.json'),
    'es': require('./locales/es.json'),
    'pt': require('./locales/pt.json'),
    'id': require('./locales/id.json'),
    'tc': require('./locales/tc.json'),
    'ma': require('./locales/ma.json'),
  }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js